export default "__VITE_ASSET__BZVL8RLV__"